var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel",class:{ expand: _vm.expanded, 'rounded-corners': _vm.roundedCorners}},[_c('div',{staticClass:"head",on:{"click":function($event){_vm.expanded = !_vm.expanded}}},[_vm._t("head")],2),_c('div',{staticClass:"panel-content"},[_c('div',{staticClass:"inner"},[_vm._t("content")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }